import React, { useEffect, useState } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

const StatisticsSection = () => {
  const [stats, setStats] = useState({
    caseNumbers: 0,
    moneySent: 0,
    date: null
  });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const statsDoc = await getDoc(doc(db, 'stats', 'values'));
        if (statsDoc.exists()) {
          const data = statsDoc.data();
          setStats({
            caseNumbers: data.caseNumbers || 0,
            moneySent: data.moneySent || 0,
            date: data.date ? new Date(data.date.seconds * 1000) : null
          });
        }
      } catch (error) {
        console.error("Error fetching stats:", error);
      }
    };

    fetchStats();
  }, []);

  return (
    <motion.div 
      className="statistics-section"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.8, duration: 0.6 }}
    >
      <h2 
        style={{
          fontSize: '24px',
          color: '#ffffff',
          textAlign: 'center',
          marginBottom: '40px'
        }}
      >
        Alhamdulillah Till Now
      </h2>
      
      <div className="statistics-container">
        <div className="statistic-item">
          <img 
            src="https://raw.githubusercontent.com/FortAwesome/Font-Awesome/6.x/svgs/solid/file-circle-check.svg"
            alt="Approved Cases"
            style={{ 
              width: '50px', 
              marginBottom: '15px',
              filter: 'invert(100%)'
            }}
          />
          <Counter endValue={stats.caseNumbers} duration={2} />
          <p style={{ 
            fontSize: '1.2rem', 
            color: '#ffffff',
            fontStyle: 'italic',
            marginTop: '10px'
          }}>
            approved cases
          </p>
        </div>

        <div className="statistic-item">
          <img 
            src="https://raw.githubusercontent.com/FortAwesome/Font-Awesome/6.x/svgs/solid/handshake-angle.svg"
            alt="Amount Distributed"
            style={{ 
              width: '50px', 
              marginBottom: '15px',
              filter: 'invert(100%)'
            }}
          />
          {/* //I want to add a + sign at the end of the counter   */}
          <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'center' }}>
            <Counter endValue={stats.moneySent} duration={4} isDecimal={true} />
            <span style={{ fontSize: '2.2rem', color: '#fff9b1', fontStyle: 'italic', marginLeft: '6px' }}>+</span>
          </div>
          <p style={{ 
            fontSize: '1.2rem', 
            color: '#ffffff',
            fontStyle: 'italic',
            marginTop: '10px'
          }}>
            sent out to families in need
          </p>
        </div>
      </div>

      {/* Updated date display */}
      <p style={{
        fontSize: '0.9rem',
        color: '#888888',
        textAlign: 'center',
        marginTop: '30px',
        fontStyle: 'italic'
      }}>
        Last updated on: {stats.date ? stats.date.toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        }) : 'Loading...'}
      </p>
    </motion.div>
  );
};

// Separate Counter component for the animation logic
const Counter = ({ endValue, duration = 2, isDecimal = false }) => {
  const [count, setCount] = useState(0);
  const controls = useAnimation();

  useEffect(() => {
    let startTime;
    let animationFrame;

    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = (timestamp - startTime) / (duration * 1000);

      if (progress < 1) {
        const currentValue = progress * endValue;
        setCount(isDecimal ? currentValue.toFixed(2) : Math.floor(currentValue));
        animationFrame = requestAnimationFrame(animate);
      } else {
        setCount(isDecimal ? endValue.toFixed(2) : endValue);
      }
    };

    controls.start({ opacity: 1 });
    animationFrame = requestAnimationFrame(animate);

    return () => {
      if (animationFrame) {
        cancelAnimationFrame(animationFrame);
      }
    };
  }, [endValue, duration, isDecimal]);

  return (
    <motion.span
      initial={{ opacity: 0 }}
      animate={controls}
      style={{
        fontSize: '2.5rem',
        fontWeight: 'bold',
        color: '#f0e68c',
        fontVariantNumeric: 'tabular-nums',
        display: 'inline-block',
        minWidth: isDecimal ? '10ch' : '4ch',
        textAlign: 'center',
      }}
    >
      {isDecimal ? `$${count}` : count}
    </motion.span>
  );
};

export default StatisticsSection; 